import axios from 'axios';
import Cookies from 'js-cookie';

import type { LoginCredentials, LoginResult } from '@/context/auth.context/auth.types';
import api from '@/lib/axiosConfig';

import { getSession } from './getSession';

import type Rollbar from 'rollbar';

export async function login({
  credentials,
  rollbar,
}: {
  credentials: LoginCredentials;
  rollbar: Rollbar;
}): Promise<LoginResult> {
  try {
    // Get CSRF token before login (Django requirement)
    const csrfToken = Cookies.get('csrftoken');
    if (!csrfToken) {
      await getSession({ rollbar });
    }

    const res = await api.post<{ detail: boolean }>(
      `/login/?app=afvalprofiel`,
      credentials,
      { withCredentials: true } // redundant but safe
    );

    return { logged: res?.data.detail, status: res?.status };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const status = error?.response?.status ?? 500;
      if (status === 403) {
        rollbar.error('Attempts to login exceeded!', error?.message, { credentials });
      }
      return { logged: error?.response?.data?.detail ?? false, status };
    }
    rollbar.error('Unknown login error', error as Rollbar.LogArgument);
    return { logged: false, status: 500 };
  }
}
